import { SUCCESS_MESSAGE, ERROR_MESSAGE, RESET_MESSAGE } from '../types/app';

const initialState = {
  messages: []
};

/* store generation messages with type SUCCESS_MESSAGE, ERROR_MESSAGE, RESET_MESSAG

    case SUCCESS_MESSAGE:
      return { ...state, messages: [messages] };

    case ERROR_MESSAGE:
      return { ...state, messages: [messages] };

    case RESET_MESSAGE:

*/

export default (state = initialState, action) => {
  let { messages } = state;
  switch (action.type) {

    case SUCCESS_MESSAGE:
      return { ...state, messages: [messages] };

    case ERROR_MESSAGE:
      return { ...state, messages: [messages] };

    case RESET_MESSAGE:
      return { ...state, messages: [] };

    default:
      return state;
  }
};
